import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { TimezoneService, Timezone } from '../../../services/timezone.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-image-swap',
	templateUrl: './image-swap.component.html',
	styleUrls: ['./image-swap.component.scss']
})
export class ImageSwapComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('imageSwapForm', { static: true }) imageSwapForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	imageSwapFormSubscription: Subscription;
	errorList;
	timezone: string;
	timezones: Array<Timezone>;
	isAdmin;

	constructor(
		private comService: ComponentService,
		private overlay: OverlayService,
		private tz: TimezoneService,
		private auth: AuthService
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.timezones = this.tz.getTimezones();

		this.imageSwapFormSubscription = this.imageSwapForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.imageSwapForm.dirty && this.imageSwapForm.invalid) ||
							this.nameField.editComponentName ||
							this.errorList.includes(true)
					)
				),
				filter((form) => this.imageSwapForm.dirty && this.imageSwapForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		for (const item of this.componentData.config.items) {
			item.date = new Date(item.swap_time * 1000);
			item.time = new Date(item.swap_time * 1000);
			item.time2 = new Date(item.swap_time * 1000);
			if (this.componentData.config.version > 1) {
				item.daily_start_time = isNaN(item.daily_start_time) ? item.daily_start_time : new Date(item.daily_start_time * 1000);
				if (item.daily_start_converted) {
					item.daily_start_converted = item.daily_start_converted;
				} else {
					item.daily_start_converted = this.dailyOverUnder(
						item.daily_start_time.getHours() * 60 +
							item.daily_start_time.getMinutes() -
							parseInt(this.componentData.config.timezone, 10)
					);
				}
			}
		}

		this.errorList = new Array(this.componentData.config.items.length);
	}

	ngOnDestroy() {
		this.imageSwapFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	timeZoneChange() {
		for (const key in this.componentData.config.items) {
			if (this.componentData.config.daily) {
				this.setDailyConverted(key);
			} else {
				if (key != '0') {
					this.dateChange(key);
				}
			}
		}
	}

	dateChange(index) {
		const day = +this.componentData.config.items[index].date.getDate();
		const month = +this.componentData.config.items[index].date.getMonth();
		const year = +this.componentData.config.items[index].date.getFullYear();
		const hours = +this.componentData.config.items[index].time.getHours();
		const minutes = +this.componentData.config.items[index].time.getMinutes();

		const UTC = new Date(year, month, day);
		const userOffset = UTC.getTimezoneOffset();

		UTC.setHours(hours, minutes - userOffset);

		this.componentData.config.items[index].swap_time = (UTC.getTime() - +this.componentData.config.timezone * 60 * 1000) / 1000;
		this.componentData.config.items[index].time2 = new Date(this.componentData.config.items[index].swap_time * 1000);
	}

	swapTypeSwitch() {
		if (this.componentData.config.daily) {
			this.componentData.config.items.splice(5);
		}
	}

	dailyStartChange(index) {
		this.setDailyConverted(index);

		if (this.componentData.config.items.length > 2) {
			for (const key in this.componentData.config.items) {
				let keyValue = parseInt(key);
				let currentFieldValue = this.getDailyValue(keyValue);

				let nextFieldValue =
					keyValue + 1 == this.componentData.config.items.length ? this.getDailyValue(0) : this.getDailyValue(keyValue + 1);

				let previousFieldValue =
					keyValue == 0 ? this.getDailyValue(this.componentData.config.items.length - 1) : this.getDailyValue(keyValue - 1);

				if (currentFieldValue != null && nextFieldValue != null && previousFieldValue != null) {
					if (
						currentFieldValue > previousFieldValue &&
						(nextFieldValue > currentFieldValue || previousFieldValue > nextFieldValue)
					) {
						this.errorList.splice(keyValue, 1, false);
					} else if (
						currentFieldValue < previousFieldValue &&
						nextFieldValue < previousFieldValue &&
						currentFieldValue < nextFieldValue
					) {
						this.errorList.splice(keyValue, 1, false);
					} else {
						this.errorList.splice(keyValue, 1, true);
					}
				} else {
					this.errorList.splice(keyValue, 1, true);
				}
			}

			if (this.errorList.includes(true)) {
				this.comService.updateDisabledSave(true);
			} else {
				this.comService.updateDisabledSave(false);
			}
		}
	}

	getDailyValue(index) {
		return this.componentData.config.items[index].daily_start_time != ''
			? this.componentData.config.items[index].daily_start_time.getHours() * 60 +
					this.componentData.config.items[index].daily_start_time.getMinutes()
			: null;
	}

	setDailyConverted(index) {
		this.componentData.config.items[index].daily_start_converted = this.dailyOverUnder(
			this.getDailyValue(index) - parseInt(this.componentData.config.timezone, 10)
		);
	}

	dailyOverUnder(amount) {
		if (amount > 1440) {
			return amount - 1440;
		} else if (amount < 0) {
			return amount + 1440;
		} else {
			return amount;
		}
	}

	addSwap() {
		if (this.componentData.config.items.length < 5 && this.componentData.config.daily) {
			this.componentData.config.items.push({
				swap_time: Math.floor(
					(this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000) /
						1000
				),
				date: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				time: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				time2: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				imageURL: '',
				linkURL: '',
				daily_start_time: '',
				daily_start_converted: ''
			});
		} else if (this.componentData.config.items.length < 101 && !this.componentData.config.daily) {
			this.componentData.config.items.push({
				swap_time: Math.floor(
					(this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000) /
						1000
				),
				date: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				time: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				time2: new Date(
					Math.floor(
						this.componentData.config.items[this.componentData.config.items.length - 1].date.getTime() + 2 * 24 * 60 * 60 * 1000
					)
				),
				imageURL: '',
				linkURL: ''
			});
			if (this.componentData.config.version > 1) {
				this.componentData.config.items[this.componentData.config.items.length - 1].daily_start_time = '';
			}
		} else {
			let swapLimit = this.componentData.config.daily ? '5 daily' : 100;
			this.overlay.updateOverlay(true, `You have reached the maximum limit of ${swapLimit} image swaps`, 'alert');
		}
	}

	removeSwap(index) {
		this.componentData.config.items.splice(index, 1);
	}

	hide(elm) {
		setTimeout(() => {
			elm.hide();
		});
	}
}
